import Nullstack from 'nullstack';
export default function IconH1({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-h-1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M19 18v-8l-2 2"
  }), "   ", Nullstack.element("path", {
    d: "M4 6v12"
  }), "   ", Nullstack.element("path", {
    d: "M12 6v12"
  }), "   ", Nullstack.element("path", {
    d: "M11 18h2"
  }), "   ", Nullstack.element("path", {
    d: "M3 18h2"
  }), "   ", Nullstack.element("path", {
    d: "M4 12h8"
  }), "   ", Nullstack.element("path", {
    d: "M3 6h2"
  }), "   ", Nullstack.element("path", {
    d: "M11 6h2"
  }), " ");
}